import routerOptions0 from "/builds/asar-studio/ticket-me-biz/ticketme/node_modules/.pnpm/nuxt@3.13.2_@parcel+watcher@2.5.0_@types+node@20.17.9_eslint@8.57.1_ioredis@5.4.1_magicast@0._ruucxm5k2o6hhsctrfbvgmy4x4/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}